import React from 'react';
import { observer } from 'mobx-react';
import { CapacityPlannerScreen } from '../../screen/CapacityPlanner/Screen';
import { formatDate } from './types';

interface Props { planner: CapacityPlannerScreen; }

@observer
export class DeveloperModal extends React.Component<Props> {
    render() {
        const p = this.props.planner;
        if (!p.developerModalOpen) return null;
        const u = p.users.find(x => x.id === p.editingDeveloperId) as any;
        return (
            <div className="cp-modal" data-test-cp-developer-modal onClick={(e) => { if (e.target === e.currentTarget) p.closeDeveloperModal(); }}>
                <div className="cp-modal-content">
                    <h3>Edit Developer</h3>
                    <div className="form-group">
                        <label>Name</label>
                        <input type="text" value={p.devModalName} onChange={(e) => p.devModalName = e.target.value} />
                    </div>
                    <div className="form-group">
                        <label>Color</label>
                        <input type="color" value={p.devModalColor} onChange={(e) => p.devModalColor = e.target.value} />
                    </div>
                    <div className="dev-edit-section">
                        <label>Working Hours per Day</label>
                        <div className="hours-grid">
                            {(['mon', 'tue', 'wed', 'thu', 'fri'] as const).map(day => (
                                <div key={day} className="hours-day">
                                    <label>{day.charAt(0).toUpperCase() + day.slice(1, 3)}</label>
                                    <input type="number" min="0" max="12" step="0.5" value={p.devModalHours[day]}
                                        onChange={(e) => { p.devModalHours = { ...p.devModalHours, [day]: parseFloat(e.target.value) || 0 }; }} />
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: 'var(--cp-text-secondary)' }}>
                            Total: <span>{p.devModalTotalHours}</span>h/week
                        </div>
                    </div>
                    <div className="holiday-section">
                        <label>Time Off / Holidays</label>
                        <div className="holiday-list">
                            {p.editingDeveloperHolidays.map(h => (
                                <div key={h.id} className="holiday-item">
                                    <div>
                                        <div>{(h as any).note || 'Time Off'}</div>
                                        <div className="holiday-dates">{formatDate(h.startDate)} - {formatDate(h.endDate)}</div>
                                    </div>
                                    <button className="btn-remove" onClick={() => p.removeHoliday(h.id as any)}>&times;</button>
                                </div>
                            ))}
                            {p.editingDeveloperHolidays.length === 0 && <div style={{ fontSize: '0.75rem', color: 'var(--cp-text-secondary)', padding: '0.5rem' }}>No holidays scheduled</div>}
                        </div>
                        <div className="add-holiday-form">
                            <div className="form-group">
                                <label>From</label>
                                <input type="date" value={p.devModalHolidayStart} onChange={(e) => p.devModalHolidayStart = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>To</label>
                                <input type="date" value={p.devModalHolidayEnd} onChange={(e) => p.devModalHolidayEnd = e.target.value} />
                            </div>
                            <button className="btn btn-sm btn-secondary" onClick={p.addHoliday}>Add</button>
                        </div>
                    </div>
                    <div className="cp-modal-actions">
                        <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={async () => {
                            if (u && window.confirm(`Delete ${u.fullName}?`)) {
                                try { await u.delete(); await p.userStore.fetch(); p.closeDeveloperModal(); p.showToast('Developer removed', 'success'); }
                                catch (e) { console.error(e); }
                            }
                        }}>Delete</button>
                        <button className="btn btn-secondary" onClick={p.closeDeveloperModal}>Cancel</button>
                        <button className="btn btn-primary" onClick={p.saveDeveloper}>Save</button>
                    </div>
                </div>
            </div>
        );
    }
}
